import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
  lineHeight: "24px",
  [theme.breakpoint.lg()]: {},
}));

export const PStyled = styled.p(() => ({
  fontSize: "19px",
}));

export const LinkStyled = styled.a(() => ({
  color: "#003672",
}));

export const Gapping = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  background: theme.color.neutral["08"],
  borderBottom: `20px solid ${theme.color.background.light}`,
  color: "#454E4F",
  [theme.breakpoint.lg()]: {
    flexDirection: "row",
  },
}));
